"use client";
import React, { createContext, useState, useContext } from "react";
import { AlertContextType, AlertState, AlertType } from "../types";
import { Alerts } from "../components";

export const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [alert, setAlert] = useState<AlertState>({ text: "", type: "success", show: false });

  const showAlert = (text: string, type: AlertType = "success") => {
    setAlert({ text, type, show: true });

    setTimeout(() => {
      setAlert({ ...alert, show: false });
    }, 3500);
  };

  return (
    <AlertContext.Provider value={{alert,showAlert}}>
      {children}
      {alert.show && <Alerts text={alert.text} type={alert.type} />}
    </AlertContext.Provider>
  );
};

export default AlertProvider;

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (context === undefined) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};
